import { Type } from "@angular/core";
import { Modal } from "src/app/models/Modal.model";
import { EndTimeModalComponent } from "./end-time/end-time.modal";
import { LearningShortcutModalComponent } from "./learning-shortcut/learning-shortcut.modal";
import { PasswordHelpModalComponent } from "./password-help/password-help.modal";
import { RecaptchaModalComponent, RecaptchaModalInputs } from "./recaptcha/recaptcha.modal";
import { StartModalComponent } from "./start-modal/start-modal.modal";
import { StartReflectionComponent } from "./start-reflection/start-reflection.modal";
import { SuccessLoginModalComponent } from "./success-login/success-login.modal";
import { TimePopupModalComponent } from "./time-popup/time-popup.modal";

export enum ModalNames {
    START_MODAL = 'StartModal',
    LEARNING_SHORTCUT = 'LearningShortcut',
    TIMER = 'Timer',
    END_TIME = 'EndTime',
    START_REFLECTION = 'StartReflection',
    RECAPTCHA = 'Recaptcha',
    SUCCESS_LOGIN = 'SuccessLogin',
    PASSWORD_HELP = 'PasswordHelp'
}

export const Modals: { [key in ModalNames]: Type<Modal> } = {
    [ModalNames.START_MODAL]: StartModalComponent,
    [ModalNames.LEARNING_SHORTCUT]: LearningShortcutModalComponent,
    [ModalNames.TIMER]: TimePopupModalComponent,
    [ModalNames.END_TIME]: EndTimeModalComponent,
    [ModalNames.START_REFLECTION]: StartReflectionComponent,
    [ModalNames.RECAPTCHA]: RecaptchaModalComponent,
    [ModalNames.SUCCESS_LOGIN]: SuccessLoginModalComponent,
    [ModalNames.PASSWORD_HELP]: PasswordHelpModalComponent,
}

export type ModalInputs = {
    [ModalNames.START_MODAL]: undefined,
    [ModalNames.LEARNING_SHORTCUT]: undefined,
    [ModalNames.TIMER]: undefined,
    [ModalNames.END_TIME]: undefined,
    [ModalNames.START_REFLECTION]: undefined,
    [ModalNames.RECAPTCHA]: RecaptchaModalInputs,
    [ModalNames.SUCCESS_LOGIN]: undefined,
    [ModalNames.PASSWORD_HELP]: undefined
};